<div [hidden]="!isShow()" class="notice flex flex-row items-center gap-4 px-4">
  <div class="icon-white">
    <!--suppress AngularNgOptimizedImage -->
    <img
      src="assets/images/valid-icon.svg"
      alt="disconnect-icon"
      height="24"
      width="24"
      loading="eager"
    />
  </div>
  <div class="pt-0.5" [class.typing]="isConnecting()">
    {{ networkNotice() }}
  </div>
</div>
